import React from "react";
import CircularChart from "../../CircularChart/CircularChart.module";
import ProgressBar from "../../ProgressBar/ProgressBar.module";
import styles from "./TrafficPart.module.css";
import NumberComponent from "../../NumberComponent";
import BlueBtn from "../../BlueBtn/BlueBtn.module";
import CtaBtns from "../../CtaBtns/CtaBtns.module";
const TrafficPart = ({
  item,
  getInfo,
  onBuyTraffic,
  isServiceActive,
  onDisabled,
}) => {
  return (
    <>
      <div className={styles.detailitem}>
        <div
          className={`${
            item.price !== 0
              ? `${styles.label}`
              : `${styles.label} ${styles.fuller}`
          } ${onDisabled && styles.makeItWhiter}`}
        >
          <i class="fa-solid fa-circle-wifi-circle-wifi"></i>
          ترافیک:
          <div className={styles.downpartdesc}>
            <div className={styles.eachdownrec}>
              <div className={styles.titlerdesc}>مصرف شده:</div>
              <div className={styles.valuerec}>
                {NumberComponent(item.traffic.usedTraffic)}
              </div>
            </div>
            {item.price !== 0 && (
              <div className={styles.eachdownrec}>
                <div className={styles.titlerdesc}>باقی مانده:</div>
                <div className={styles.valuerec}>
                  {NumberComponent(
                    item.traffic.remainingTraffic < 0
                      ? 0
                      : item.traffic.remainingTraffic
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        {item.price !== 0 && (
          <CircularChart
            value={
              item.traffic.percentUsage > 100 ? 100 : item.traffic.percentUsage
            }
            maxValue={100}
            status={item.traffic.status}
            onDisabled={onDisabled}
          />
        )}
      </div>
      {item.price !== 0 && (
        <>
          {isServiceActive(item.remainingTime) ? (
            <>
              {!onDisabled && (
                <BlueBtn icon="fa-solid fa-cart-plus" onAtion={onBuyTraffic}>
                  خرید ترافیک
                </BlueBtn>
              )}
              {onDisabled && (
                <CtaBtns icon="fa-solid fa-cart-plus" onAtion={onBuyTraffic}>
                  خرید ترافیک
                </CtaBtns>
              )}
            </>
          ) : (
            <div className={styles.disablebuytr}>
              جهت تمدید ترافیک ابتدا سرویس خود را تمدید نمایید.
            </div>
          )}
        </>
      )}
    </>
  );
};

export default TrafficPart;
